import styled from "@emotion/styled";
import { FC, HTMLProps, PropsWithChildren } from "react";
import {
  Dialog,
  Modal,
  ModalOverlay,
  ModalOverlayProps
} from "react-aria-components";
import { IconDialogClose } from "../../../icons/IconDialogClose"; // Don't change this. `icons` folder is outside `src` -> results in a type check error without the dots
import { CustomDialogCloseButton } from "./CustomDialogCloseButton";

const StyledModalOverlay = styled(ModalOverlay)`
  label: CustomStyledModalOverlay;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
`;

const StyledModal = styled(Modal)`
  label: CustomStyledModal;
  --popup-dialog-width: 342px;
  flex: 0 0 auto;
  width: var(--popup-dialog-width);
  border-radius: 24px;
  background-color: var(--color-white);
  padding: 0;
  text-align: left;
  font-family: var(--font-family);
  font-feature-settings:
    "liga" off,
    "clig" off;
`;

const StyledDialog = styled(Dialog)`
  label: StyledDialog;
  position: relative;
`;

export const CustomDialog: FC<
  ModalOverlayProps & PropsWithChildren<HTMLProps<HTMLDivElement>>
> = ({ children, ...props }) => {
  return (
    <StyledModalOverlay>
      <StyledModal {...props}>
        <StyledDialog>
          <CustomDialogCloseButton slot={"close"}>
            <IconDialogClose />
          </CustomDialogCloseButton>
          {children}
        </StyledDialog>
      </StyledModal>
    </StyledModalOverlay>
  );
};
